(function () {

    angular
        .module('smartertoolsApp')
        .controller('supportTicketReportController', ['supportService', '$rootScope', supportTicketReportController]);

    function supportTicketReportController(supportService, $rootScope) {
        const vm = this;
        vm.AllTickets = null;
        vm.isLoading = true;
        vm.loadingError = null;

        // Functions
        vm.refreshData = refreshData;

        activate();

        // -----------------------------------------------

        function activate() {
            $rootScope.$on('authentication:logged-in', () => vm.refreshData());
            $rootScope.$on('authentication:logged-out', () => vm.refreshData());
            vm.refreshData();
        }

        function refreshData() {
            supportService.getAllTickets()
                .then((data) => {
                    vm.AllTickets = data;
                    vm.isLoading = false;
                })
                .catch(() => {
                    vm.loadingError = 'There was a problem loading this information.  Please try again later.';
                });
        }
    }

})();